export default "__VITE_ASSET__Bu8TxdKM__"